/* Collagen video rail: tap to play with sound, tap again to pause; only one plays at a time */
(function () {
  'use strict';
  var frames = document.querySelectorAll('.ew-video-frame');
  if (!frames.length) return;
  var stopAll = function (except) {
    frames.forEach(function (fr) {
      var v = fr.querySelector('video');
      if (v && v !== except && !v.paused) { v.pause(); fr.classList.remove('is-playing'); }
    });
  };
  frames.forEach(function (fr) {
    var v = fr.querySelector('video'), btn = fr.querySelector('.ew-play');
    if (!v || !btn) return;
    var toggle = function () {
      if (v.paused) { stopAll(v); v.muted = false; v.play(); fr.classList.add('is-playing'); }
      else { v.pause(); fr.classList.remove('is-playing'); }
    };
    btn.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
    v.addEventListener('pause', function () { fr.classList.remove('is-playing'); });
  });
})();
